import { watch } from 'vue'
import { useRoute } from 'vue-router'
import { formatTitle, refineTitle } from '../utils/pageTitle'

type Parts = string | Array<string | null | undefined> | null | undefined | false

/**
 * Data-aware tab title for detail pages. The router sets the route's static
 * meta.title on every navigation; this replaces it once the item has loaded.
 * While `parts` is empty the static title stays (that is the loading title).
 *
 *   usePageTitle(() => product.value && [product.value.name, 'Products'],
 *                { notFound: () => !!error.value })
 */
export function usePageTitle(parts: () => Parts, opts: { notFound?: () => boolean } = {}) {
    const route = useRoute()
    watch(
        () => {
            if (opts.notFound?.()) return formatTitle('Not found', route.meta.title as string | undefined)
            const value = parts()
            if (!value) return null
            return formatTitle(...(Array.isArray(value) ? value : [value]))
        },
        title => { if (title) refineTitle(title) },
        { immediate: true },
    )
}
